import { Injectable } from '@angular/core';
import { VISMA_MENU } from '../../const/visma-menu';
import { Profile } from '../auth/profile';
import nc3navigation from 'src/assets/nc3-navigation-native/nc3navigation';
import { NavItem } from './nav-item';
import { PATH } from 'src/app/const/path';
import { CONTEXT_TYPE } from 'src/app/const/context-type';
import { DISTRIBUTOR_MENU, DISTRIBUTOR_MENU_COMPANY_MOVE } from 'src/app/const/distributor-menu';
import { USER_MENU } from 'src/app/const/user-menu';
import { HOSTNAME } from 'src/app/const/hostname';
import { OLD_ADMIN_HOSTNAME } from 'src/app/const/old-admin-hostname';
import { SESSION_STORAGE_KEY } from 'src/app/const/session-storage-key';
import { ENV } from 'src/app/const/env';
import { COMPANY_MOVE_RESPONSIBLE, DISTRUBUTOR_ADMINISTRATOR } from '../auth/roles';

@Injectable({
  providedIn: 'root'
})
export class NavbarService {

  constructor() { }

  private getUrlParameter(name: string, search: string): string {
    name = name.replace(/\[/, String.raw`\[`).replace(/\]/, String.raw`\]`);
    let regex = new RegExp(String.raw`[\?&]` + name + '=([^&#]*)');
    let results = regex.exec(search);
    return results === null ? '' : decodeURIComponent(results[1].replaceAll('+', ' '));
  }

  getContextId(search: string) {
    let id = this.getUrlParameter('contextSelector:switchContext', search);
    if (!id) {
      id = sessionStorage.getItem(SESSION_STORAGE_KEY.adminUIContextId);
    }
    if (id === 'null' || id === 'undefined') {
      id = null;
    }
    return id;
  }

  getContextType(pathname: string): string {
    let type: string;
    if (pathname.includes(PATH.user)) {
      type = CONTEXT_TYPE.user;
    } else if (pathname.includes(PATH.distributor)) {
      type = CONTEXT_TYPE.distributor;
    } else if (pathname.includes(PATH.visma)) {
      type = CONTEXT_TYPE.visma;
    }
    return type;
  }

  handleDirectLink(pathname): void {
    if (pathname !== '/' && pathname !== '' && !pathname.includes('index.html') &&
      !pathname.includes('debug.html') && !pathname.includes('context.html')) {
      const path = sessionStorage.getItem(SESSION_STORAGE_KEY.adminUIPath);
      if (path !== pathname || path.includes(PATH.tasks)) {
        sessionStorage.removeItem(SESSION_STORAGE_KEY.adminUIContextId);
      }
      sessionStorage.setItem(SESSION_STORAGE_KEY.adminUIPath, pathname);
    }
  }

  handleContextId(id: string): void {
    sessionStorage.setItem(SESSION_STORAGE_KEY.adminUIContextId, id);
  }

  setProfileItems(id: string, url: string): void {
    if (id !== null && id !== undefined) {
      sessionStorage.setItem(SESSION_STORAGE_KEY.adminUIContextId, id);
    }
    sessionStorage.setItem(SESSION_STORAGE_KEY.adminUIPath, url);
  }

  removeProfileItems(): void {
    sessionStorage.removeItem(SESSION_STORAGE_KEY.adminUIContextId);
    sessionStorage.removeItem(SESSION_STORAGE_KEY.adminUIPath);
  }

  private getNavItem(menu, path, defaultPath) {
    return {
      menu: menu,
      path: path || defaultPath
    }
  }

  private getOldAdminHostname(hostname: string): string {
    if (hostname === HOSTNAME.localhost) {
      return OLD_ADMIN_HOSTNAME.localhost;
    } else if (hostname === HOSTNAME.sit) {
      return OLD_ADMIN_HOSTNAME.sit;
    } else if (hostname === HOSTNAME.int) {
      return OLD_ADMIN_HOSTNAME.int;
    } else if (hostname === HOSTNAME.stag) {
      return OLD_ADMIN_HOSTNAME.stag;
    } else if (hostname === HOSTNAME.prod) {
      return OLD_ADMIN_HOSTNAME.prod;
    }
  }

  private setHref(menuItems: any[], hostname, id): any[] {
    for (let i = 0, len = menuItems.length; i < len; i++) {
      if (menuItems[i].href) {
        if (!menuItems[i].href.includes('https://')) {
          menuItems[i].href = 'https://' + hostname + menuItems[i].href + '?contextSelector:switchContext=' + id;
        } else if (menuItems[i].href.includes('?contextSelector:switchContext=')) {
          menuItems[i].href = menuItems[i].href.replace(/=\d+/, '=' + id);
        }
      }
    }
    return menuItems;
  }

  private indexOf(array: nc3navigation.MenuItem[], item: { id: string, value: boolean }): number {
    let index = -1;
    if (array?.length) {
      for (let i = 0, len = array.length; i < len; i++) {
        if (item.id === array[i].id) {
          index = i;
          break;
        }
      }
    }
    return index;
  }

  setMenuItemsDisplayStatus(menu: nc3navigation.MenuItem[], args: { id: string, value: boolean }[]): any[] {
    if (args?.length) {
      for (let i = 0, len = args.length; i < len; i++) {
        let index = this.indexOf(menu, args[i]);
        if (index !== -1) {
          menu[index].shown = args[i].value;
        }
      }
    }
    return menu;
  }

  getRedirectLink(hostname: string, item: nc3navigation.ContextItem) {
    const h = this.getOldAdminHostname(hostname);
    let link = `https://${h}/admin`;
    if (item.type === CONTEXT_TYPE.visma) {
      link += '/supportvisma/supportuser/userstab/';
    } else if (item.type === CONTEXT_TYPE.distributor) {
      link += '/supportdistributor/partnersupportcontacts/partnersupportcontactstab/';
    }
    link += `?contextSelector:switchContext=${item.id}`;
    return link;
  }

  getUserDetailsLink(hostname: string, idCustomer: string | number, idUser: number) {
    const h = this.getOldAdminHostname(hostname);
    let link = `https://${h}/admin/usersandroles/users/userdetailstab/${idUser}?contextSelector:switchContext=${idCustomer}`;
    return link;
  }

  getSelectedAppPrefix(type: string) {
    let prefix = 'Visma.net';
    if (type === CONTEXT_TYPE.user) {
      prefix = ''
    }
    return prefix;
  }

  getProfileDefaultPath(profile: Profile): string {
    let path;
    if (profile.type === CONTEXT_TYPE.visma) {
      path = PATH.visma_support_companies;
    } else if (profile.type === CONTEXT_TYPE.distributor) {
      path = PATH.distributor_support;
    } else if (profile.type === CONTEXT_TYPE.user) {
      path = PATH.user_details_myroles;
    }
    return path;
  }

  getProfileNavItem(profile: Profile, hostname: string, resetProfileItems?: boolean): NavItem {
    let path, item, menu, args;
    if (!resetProfileItems) {
      path = sessionStorage.getItem(SESSION_STORAGE_KEY.adminUIPath);
    }

    if (profile.type === CONTEXT_TYPE.visma) {
      item = this.getNavItem(VISMA_MENU, path, PATH.visma_support_companies);
    } else if (profile.type === CONTEXT_TYPE.distributor) {
      hostname = this.getOldAdminHostname(hostname);

      if (profile.roles?.includes(DISTRUBUTOR_ADMINISTRATOR)) {
        menu = DISTRIBUTOR_MENU;
        args = [{ id: 'companyMove', value: profile.roles?.includes(COMPANY_MOVE_RESPONSIBLE) }];
        menu.secondLevelMenu = this.setMenuItemsDisplayStatus(menu.secondLevelMenu, args);
      } else {
        menu = DISTRIBUTOR_MENU_COMPANY_MOVE;
      }
      menu.firstLeveLMenu = this.setHref(menu.firstLeveLMenu, hostname, profile.id);
      menu.secondLevelMenu = this.setHref(menu.secondLevelMenu, hostname, profile.id);
      item = this.getNavItem(menu, path, PATH.distributor_support_companymove)

    } else if (profile.type === CONTEXT_TYPE.user) {
      item = this.getNavItem(USER_MENU, path, PATH.user_details_myroles);
    }
    return item;
  }

  getEnviroment(hostname: string): string {
    if (hostname === HOSTNAME.localhost) {
      return ENV.localhost;
    } else if (hostname === HOSTNAME.sit) {
      return ENV.sit;
    } else if (hostname === HOSTNAME.int) {
      return ENV.int;
    } else if (hostname === HOSTNAME.stag) {
      return ENV.stag;
    } else if (hostname === HOSTNAME.prod) {
      return ENV.prod;
    }
  }

  getCulture(language: string): string {
    let culture = 'en-US';
    if (language === 'da') {
      culture = 'da-DK';
    } else if (language === 'fi') {
      culture = 'fi-FI';
    } else if (language === 'nb') {
      culture = 'nb-NO';
    } else if (language === 'no') {
      culture = 'no-NO';
    } else if (language === 'nl') {
      culture = 'nl-NL';
    } else if (language === 'sv') {
      culture = 'sv-SE';
    }
    return culture;
  }

}
